import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_COMPANY_DETAILS,
  GET_PARENT_COMPANYLIST,
  GET_COMPANY_LOGO,
} from "resources/actionTypes";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  fetchCompanyLogoDetails,
  fetchCompanyProfile,
  fetchParentCompanyList,
} from "services/CompanyService";
import store from "redux/store";
import { getCompanyCity } from "redux/actions/ReservationAction";

function* companyProfile(action) {
  // const payload = action.payload || {};
  // const comanyProfile = yield call(fetchCompanyProfile, payload.id);

  const payload = action.payload || {};

  const companyId = payload?.id?.id || payload?.id;

  const comanyProfile = yield call(fetchCompanyProfile, companyId);

  if (comanyProfile.success) {
    yield put({
      type: GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_SUCCESS,
      companyProfile: comanyProfile?.data,
    });
    if (payload?.id?.type === "newBooking") {
      store.dispatch(
        getCompanyCity({ contractId: comanyProfile?.data?.Contracts?.[0]?.id }),
      );
    }
  } else {
    yield put({
      type: GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_FAILED,
      message: comanyProfile.message,
    });
    toast.error(comanyProfile.message || "Fetching companylist Failed");
  }
}

export function* onCompanyProfileWatcher() {
  yield takeEvery(
    GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_REQUESTED,
    companyProfile,
  );
}

function* parentCompanyList(action) {
  const payload = action.payload || {};

  const comanyProfile = yield call(fetchParentCompanyList, payload.id);

  if (comanyProfile.success) {
    yield put({
      type: GET_PARENT_COMPANYLIST.GET_PARENT_COMPANYLIST_SUCCESS,
      companyProfile: comanyProfile?.data,
    });
  } else {
    yield put({
      type: GET_PARENT_COMPANYLIST.GET_PARENT_COMPANYLIST_FAILED,
      message: comanyProfile.message,
    });
    if (comanyProfile.message) {
      // toast.error(userUpdateSubVendor.message);
    } else {
      toast.error("Fetching companylist Failed");
    }
  }
}

export function* parentCompanyListWatcher() {
  yield takeEvery(
    GET_PARENT_COMPANYLIST.GET_PARENT_COMPANYLIST_REQUESTED,
    parentCompanyList,
  );
}

function* companyLogo(action) {
  const response = yield call(fetchCompanyLogoDetails, action.payload.id);

  if (response.success) {
    yield put({
      type: GET_COMPANY_LOGO.GET_COMPANY_LOGO_SUCCESS,
      logoData: response.data,
    });
  } else {
    yield put({
      type: GET_COMPANY_LOGO.GET_COMPANY_LOGO_FAILED,
    });
  }
}

export function* companyLogoWatcher() {
  yield takeEvery(GET_COMPANY_LOGO.GET_COMPANY_LOGO_REQUESTED, companyLogo);
}
